import { v4 as uuidv4 } from 'uuid';
import { getTotalSubscribersAPI } from './api';

// Site-wide count for the Hero's "Trusted by..." line — fetched once, fire-
// and-forget, alongside the other calls in usePublisherInit(); not polled.
async function getTotalSubscribers() {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.observed.totalSubscribersLoading = true;
    try {
        const res = await getTotalSubscribersAPI({ token: session?.token, traceId });
        this.totalSubscribers = res?.data?.data?.total ?? res?.data?.total ?? null;
    } catch (error) {
        console.error('getTotalSubscribers error:', { error, traceId });
        this.totalSubscribers = null;
    } finally {
        this.observed.totalSubscribers = uuidv4();
        this.observed.totalSubscribersLoading = false;
    }
}

export default getTotalSubscribers;
